import { EJWPlayerBucket } from '../types';

interface IJWPlayerId {
  videoId: string;
  playerId: string;
  captionsId: string;
  videoBucket: EJWPlayerBucket;
}

export default function formatJWPlayerId(externalId: string): IJWPlayerId {
  const [videoId, playerId, captionsId, videoBucket] = externalId.split('-');

  if (!videoId) {
    throw new Error('JWPlayer video ID missing');
  }
  if (!playerId) {
    throw new Error('JWPlayer player ID missing');
  }
  if (!captionsId) {
    throw new Error('JWPlayer captions ID missing');
  }
  if (!videoBucket) {
    throw new Error('JWPlayer video bucket missing');
  }
  if (
    videoBucket !== EJWPlayerBucket.Recorded &&
    videoBucket !== EJWPlayerBucket.Livestream
  ) {
    throw new Error('JWPlayer video bucket invalid');
  }

  return { videoId, playerId, captionsId, videoBucket };
}
